<template>
  <card-item card="item_text" :tabs="tabs" :activeTab="activeTab" :id="id">
  
  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key:'information_card', key:'info',
          component: () => import("./Info"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>